import "./debug.scss";
import { DebugContent } from "./debug-content";
import { Accordion } from "react-bootstrap";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchDebugInfo } from "../../../app/store/debug/actions";
import { setLoader } from "../../../app/store/ui/actions";
import MiddlewareEntities from "../../../constants/MiddlewareEntities";

export const DebugBar = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchDebugInfo());
    dispatch(setLoader(true, MiddlewareEntities.DEBUG));
  }, []);

  return (
    <div className="debug-container">
      <Accordion className="debug-accordion" alwaysOpen>
        <Accordion.Item eventKey="0" className="text-15 dark-blue-text">
          <Accordion.Header>
            Debug Info
          </Accordion.Header>
          <Accordion.Collapse eventKey="0">
            <Accordion.Body style={{ minHeight: '600px' }}>
              <DebugContent />
            </Accordion.Body>
          </Accordion.Collapse>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};
